import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Search, AlertTriangle, Info } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { L, card } from "./shared";

export const CompetitorForm = ({ clientId, config, credits, initial, onDone }) => {
  const [f, setF] = useState({ profili: "", settore: "", zona: "", competitor: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const src = initial || config?.prefill;
    if (src) setF({ profili: (src.profili || []).join("\n"), settore: src.settore || "", zona: src.zona || "", competitor: src.competitor || "" });
  }, [config, initial]);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const full = !!credits && credits.usati >= credits.limite;
  const [stima, setStima] = useState(false);
  useEffect(() => { if (full) setStima(true); }, [full]);
  const go = async (forceStima) => {
    setBusy(true);
    try {
      const body = { ...f, solo_stima: forceStima === true || stima, profili: f.profili.split("\n").map((x) => x.trim()).filter(Boolean).slice(0, 6) };
      onDone((await api.post(`/admin-ai/clients/${clientId}/competitor/analizza`, body)).data);
      toast.success("Analisi completata");
    } catch (e) {
      if (e?.response?.status === 409) { setStima(true); toast.error(errMsg(e), { action: { label: "Usa modalità stima", onClick: () => go(true) } }); }
      else toast.error(errMsg(e));
    }
    finally { setBusy(false); }
  };
  const web = config?.ricerca_web && !stima;
  return (
    <div className={card} data-testid="competitor-form">
      {config && !web && (
        <div className="mb-3 flex gap-2 rounded-xl border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900" data-testid="competitor-no-web">
          <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" /><span><b>Ricerca web non configurata.</b> L'analisi verrà prodotta solo dall'AI e sarà interamente etichettata come «stima», senza fonti.</span>
        </div>
      )}
      <div className="mb-3 flex gap-2 text-xs text-slate-600" data-testid="competitor-ig-note"><Info className="h-4 w-4 shrink-0" />I profili Instagram non vengono letti direttamente (Instagram blocca l'accesso automatico): l'analisi usa fonti web pubbliche.</div>
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="sm:col-span-2"><L>Profili social e sito del cliente (uno per riga)</L><Textarea rows={3} value={f.profili} onChange={set("profili")} className="rounded-xl bg-white" data-testid="competitor-form-profili" /></div>
        <div><L>Settore</L><Input value={f.settore} onChange={set("settore")} className="rounded-xl bg-white" data-testid="competitor-form-settore" /></div>
        <div><L>Zona</L><Input value={f.zona} onChange={set("zona")} placeholder="es. Udine, Friuli Venezia Giulia" className="rounded-xl bg-white" data-testid="competitor-form-zona" /></div>
        <div className="sm:col-span-2"><L>Competitor noti (nomi o link, uno per riga – facoltativo)</L><Textarea rows={3} value={f.competitor} onChange={set("competitor")} className="rounded-xl bg-white" data-testid="competitor-form-competitor" /></div>
      </div>
      {config?.ricerca_web && (
        <label className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-[#0A1128]"><Checkbox checked={stima} onCheckedChange={(v) => setStima(!!v)} data-testid="competitor-form-stima" />Solo stima AI (nessun credito di ricerca web)</label>
      )}
      <div />
      <Button onClick={() => go()} disabled={busy} className="mt-4 w-full sm:w-auto rounded-full bg-[#E8173A] hover:bg-[#C8102E] font-bold" data-testid="competitor-form-run">
        {busy ? <><Loader2 className="h-4 w-4 mr-1.5 animate-spin" />{web ? "Ricerca sul web e analisi in corso (fino a 1-2 minuti)…" : "Analisi AI in corso…"}</> : <><Search className="h-4 w-4 mr-1.5" />{web ? "Avvia analisi" : "Avvia analisi (solo stima AI)"}</>}
      </Button>
    </div>
  );
};
